export default __webpack_public_path__ + "static/media/dongho.40567a84.png";